import React from 'react'
import { Link } from 'react-router-dom'
import config from './Config'

const Unauthorized = () => {
    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #f5eeff 0%, #e5fafc 100%)',
            padding: 24,
        }}>
            <div className="text-center" style={{ maxWidth: 480 }}>
                <div style={{
                    width: 100,
                    height: 100,
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, rgba(164,76,215,0.15), rgba(12,172,194,0.15))',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 24px',
                }}>
                    <i className="icon-user-lock" style={{ fontSize: 42, color: '#A44CD7' }}></i>
                </div>

                <h1 style={{ fontSize: 72, fontWeight: 800, color: '#A44CD7', lineHeight: 1, marginBottom: 8 }}>403</h1>

                <h3 style={{ fontWeight: 700, color: '#1a1a2e', marginBottom: 12 }}>Access Denied</h3>

                <p style={{ color: '#777', fontSize: 15, lineHeight: 1.7, marginBottom: 32 }}>
                    You don't have permission to view this page.<br />
                    Please contact your administrator if you believe this is an error.
                </p>

                <Link
                    to={config.appUrl}
                    className="btn fw-semibold px-5 py-2 text-white"
                    style={{
                        background: 'linear-gradient(135deg, #A44CD7, #0CACC2)',
                        borderRadius: 12,
                        fontSize: 15,
                        border: 'none',
                        textDecoration: 'none',
                    }}
                >
                    <i className="icon-home me-2"></i>Go to Dashboard
                </Link>
            </div>
        </div>
    )
}

export default Unauthorized
